import { getMediaEventDayNum, getMediaEventIds, } from 'redux/utils'

import * as types from './actionTypes'

// ***********
// *** NAV ***
// ***********

export const navHome = () => ({
  type: types.LOCATION_HOME,
})

export const navViewAllTrips = () => ({
  type: types.LOCATION_VIEW_ALL_TRIPS,
})

export const navViewTrip = ({ tripId, }) => ({
  type: types.LOCATION_VIEW_TRIP,
  payload: { tripId, },
})

export const navViewTripAsList = ({ tripId, }) => ({
  type: types.LOCATION_VIEW_TRIP_AS_LIST,
  payload: { tripId, },
})

export const navViewTripAsMap = ({ tripId, }) => ({
  type: types.LOCATION_VIEW_TRIP_AS_MAP,
  payload: { tripId, },
})

export const navViewEvent = ({ tripId, eventId, }) => ({
  type: types.LOCATION_VIEW_TRIP_EVENT,
  payload: { tripId, eventId, },
})

export const navViewEventInfo = ({ tripId, eventId, }) => ({
  type: types.LOCATION_VIEW_TRIP_EVENT_INFO,
  payload: { tripId, eventId, },
})

export const navViewListEventInfo = ({ tripId, eventId, }) => ({
  type: types.LOCATION_VIEW_TRIP_LIST_EVENT_INFO,
  payload: { tripId, eventId, },
})

export const navViewEventInfoDayMedia = ({
  tripId,
  eventId,
  dayNum,
  mediaId,
  mediaType,
}) => ({
  type: types.LOCATION_VIEW_TRIP_EVENT_INFO_DAY_MEDIA,
  payload: { tripId, eventId, dayNum, mediaId, mediaType, },
})

export const navViewListEventInfoDayMedia = ({
  tripId,
  eventId,
  dayNum,
  mediaId,
  mediaType,
}) => ({
  type: types.LOCATION_VIEW_TRIP_LIST_EVENT_INFO_DAY_MEDIA,
  payload: { tripId, eventId, dayNum, mediaId, mediaType, },
})

export const navAddTrip = () => ({
  type: types.LOCATION_ADD_TRIP,
})

export const navEditTrip = ({ tripId, }) => ({
  type: types.LOCATION_EDIT_TRIP,
  payload: { tripId, },
})

// **********************************
// *** STATE SPECIFIC ACTION CREATORS
// **********************************

function getEventViewState({ state, mediaId, }) {
  const tripId = state.trips ? state.trips.selectedTripId : undefined
  if (tripId && state.trips.selectedEventId && state.trips.tripData[tripId]) {
    let mediaType
    let dayNum
    let eventId
    if (
      (mediaId && state.trips.tripData[tripId].media) ||
      state.trips.tripData[tripId].media[mediaId]
    ) {
      mediaType = state.trips.tripData[tripId].media[mediaId].type
      const events = state.trips.tripData[tripId].events
      eventId = state.trips.selectedEventId
      dayNum = getMediaEventDayNum({ events, eventId, mediaId, })
      // HACK
      // if this media item does not exist within the current event then find the event
      // and day it does exist in...
      if (!dayNum) {
        eventId = getMediaEventIds({ events, mediaId, })[0]
        dayNum = getMediaEventDayNum({ events, eventId, mediaId, })
      }
      return {
        tripId,
        eventId,
        mediaType,
        dayNum,
        listingMode: state.trips.listingMode,
      }
    }
      // no media id provided so return current state
    return {
      tripId: state.trips.selectedTripId,
      eventId: state.trips.selectedEventId,
      listingMode: state.trips.listingMode,
    }
  }
  return undefined
}

// view media based on current app display state
export const navViewMedia = ({ mediaId, }) => (dispatch, getState) => {
  const state = getState()
    // if we are currently viewing an event, then dispatch the relevant contextual action (list view v's map view)
  const eventView = getEventViewState({ state, mediaId, })
  if (eventView) {
    const { tripId, eventId, mediaType, dayNum, } = eventView
      // we are currently viewing a trip event, so dispatch the action based on if in listing view
    if (eventView.listingMode) {
      dispatch(
          navViewListEventInfoDayMedia({
            tripId,
            eventId,
            dayNum,
            mediaId,
            mediaType,
          })
        )
    } else {
      dispatch(
          navViewEventInfoDayMedia({
            tripId,
            eventId,
            dayNum,
            mediaId,
            mediaType,
          })
        )
    }
  } else {
      // TODO hide event in 'just events mode'
  }
}

// close media based on current app display state
export const navCloseMedia = () => (dispatch, getState) => {
  const state = getState()
    // if we are currently viewing an event, then dispatch the relevant contextual action (list view v's map view)
  const eventView = getEventViewState({ state, })
  if (eventView) {
      // we are currently viewing a trip event, so dispatch the action based on if in listing view
    const { tripId, eventId, } = eventView
    if (eventView.listingMode) {
      dispatch(navViewListEventInfo({ tripId, eventId, }))
    } else {
      dispatch(navViewEventInfo({ tripId, eventId, }))
    }
  } else {
      // TODO show event in 'just events mode'
    debugger
  }
}

// ****************
// *** SETTINGS ***
// ****************

export const setVideoResolutionDisplay = ({ videoResolutionDisplay, }) => ({
  type: types.SET_VIDEO_RESOLUTION_DISPLAY,
  payload: { videoResolutionDisplay, },
})

// ************
// *** TRIP ***
// ************

export const createTrip = ({ tripId, tripData, }) => ({
  type: types.ACTION_CREATE_NEW_TRIP,
  payload: { tripId, tripData, },
})
export const addTripLocation = ({ tripId, location, to, }) => ({
  type: types.ACTION_ADD_TRIP_LOCATION,
  payload: { tripId, location, to, },
})
export const updateTripItinerary = ({ tripId, locationId, itinerary, }) => ({
  type: types.ACTION_UPDATE_TRIP_ITINERARY,
  payload: { tripId, locationId, itinerary, },
})
export const updateTripLocation = ({ tripId, location, to, }) => ({
  type: types.ACTION_UPDATE_TRIP_LOCATION,
  payload: { tripId, location, to, },
})

// ****************
// *** UI STATE ***
// ****************

export const openMagicDrawer = () => ({
  type: types.OPEN_MAGIC_DRAWER,
})

export const closeMagicDrawer = () => ({
  type: types.CLOSE_MAGIC_DRAWER,
})



// WEBPACK FOOTER //
// ./src/redux/actions/index.js